import React from 'react';

/**
 * Allow type inference when wrapping Generic React components with forwardRef
 * @see: https://www.totaltypescript.com/forwardref-with-generic-components
 */
export function typedForwardRef<T, P = {}>(
  render: (props: P, ref: React.Ref<T>) => React.ReactNode
): (props: P & React.RefAttributes<T>) => React.ReactNode {
  return React.forwardRef(render) as any;
}
